import React, { ReactNode } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { HelpOutline, SvgIconComponent, Close } from "@material-ui/icons";
import {
  Grid,
  Drawer,
  IconButton,
  Divider,
  Typography,
} from "@material-ui/core";
import { AppBarButton } from "../SecondaryAppBar";

const DRAWER_WIDTH = 400;

export type PersistentDrawerProps = {
  children: ReactNode;
  handleDrawerToggle: (isOpen: boolean) => void;
  open: boolean;
  text?: string;
  Icon?: SvgIconComponent;
  disabled?: boolean;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      flexGrow: 1,
    },
    drawerPaper: {
      width: DRAWER_WIDTH,
    },
    drawerContent: {
      padding: 20,
    },
    button: {
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.04) !important",
      },
    },
    heading: {
      marginTop: 18,
      marginBottom: 10,
    },
  })
);
export const PersistentDrawer: React.FC<PersistentDrawerProps> = ({
  text,
  Icon,
  children,
  disabled,
  handleDrawerToggle,
  open,
}) => {
  const classes = useStyles();

  return (
    <>
      <AppBarButton
        Icon={Icon || HelpOutline}
        //text={text}
        tooltip={text}
        onClick={() => handleDrawerToggle(!open)}
        disabled={disabled}
      />
      <Drawer
        variant="persistent"
        anchor="right"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Grid container spacing={1}>
          <Grid item xs={2} style={{ marginTop: 10 }}>
            <IconButton
              onClick={() => handleDrawerToggle(!open)}
              className={classes.button}
            >
              <Close />
            </IconButton>
          </Grid>
          <Grid item xs={10}>
            <Typography variant="h1" className={classes.heading}>
              {text}
            </Typography>
          </Grid>
        </Grid>
        <Divider />
        <div className={classes.drawerContent}>{children}</div>
      </Drawer>
    </>
  );
};
